<template>
  <div>
    <div :class="s.logo">广东智选保险代理有限公司</div>
    <div :class="s.navBar">
      <div :class="s.as">
        <a v-for="({ topic, to }, index) in topics" :key="index"
          :class="[s.mavItem, { [s.heighLight]: index === selected }]" @click="changeSelect(index, to)">
          {{ topic }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { topics } from '@/constant';

export default {
  computed: {
    s() {
      return this.$style;
    },
  },
  data() {
    return {
      topics,
      selected: 0
    };
  },
  mounted() {
    this.$nextTick(() => {
      const selected = ~~this.$route.query.selected;
      this.selected = selected;
    });
  },
  methods: {
    changeSelect(index, to) {
      if (!to) {
        return
      }

      if (to.startsWith('https://') || to.startsWith('http://')) {
        window.open(to, '_blank');
        return
      }
      this.selected = index;
      this.$router.push(to);
    },
  },
};
</script>

<style scoped lang="less" module>
.logo {
  background-color: #fff;
  height: 88px;
  line-height: 88px;
  text-align: center;
  color: #00468c;
  font-weight: bold;
  font-size: 24px;
}

.navBar {
  height: 58px;
  background-color: #00468c;
  padding: 0 344px;

  //   min-width: 1075px;
  .as {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 1075px;
    margin: 0 auto;
  }
}

.mavItem {
  display: block;
  height: 58px;
  color: #fff;
  line-height: 58px;
  font-size: 14px;
  text-align: center;
  padding: 0 30px;
  font-weight: bold;
  cursor: pointer;
}

.heighLight {
  background-color: #fff;
  color: #00468c;
}
</style>
